<template>
  <!-- <BackButtonComponent /> -->
  <div class="flex flex-col gap-5">
    <TitlePrimary :title="$t('settings.titles.administrator')" />

    <CardComponent>
      <div v-if="!loadingAdmin">
        <form action="" class="flex flex-wrap justify-center items-center gap-3">
          <InputFrom type="text" class="w-full sm:w-[48%] md:w-[23%]" :labelColor="'#385660'"
            :label="$t('settings.labels.accountName')"
            :modelValue="accountName || adminData.name || '-'" disabled />
          <InputFrom type="email" class="w-full sm:w-[48%] md:w-[23%]" :labelColor="'#385660'"
            :label="$t('settings.labels.address')"
            :modelValue="adminData.address || '-'" disabled />
          <InputFrom type="text" class="w-full sm:w-[48%] md:w-[23%]" :labelColor="'#385660'"
            :label="$t('settings.labels.accountType')"
            :modelValue="accountType || '-'" disabled />
          <InputFrom type="text" class="w-full sm:w-[48%] md:w-[23%]" :labelColor="'#385660'"
            :label="$t('settings.labels.province')"
            :modelValue="adminData.state || '-'" disabled />
          <InputFrom type="text" class="w-full sm:w-[48%] md:w-[23%]" :labelColor="'#385660'"
            :label="$t('settings.labels.cif')"
            :modelValue="adminData.cif || '-'" disabled />
          <InputFrom type="text" class="w-full sm:w-[48%] md:w-[23%]" :labelColor="'#385660'"
            :label="$t('settings.labels.postalCode')"
            :modelValue="adminData.postal_code || '-'" disabled />
          <InputFrom type="text" class="w-full sm:w-[48%] md:w-[23%]" :labelColor="'#385660'"
            :label="$t('settings.labels.legalRepName')"
            :modelValue="adminData.legal_rep_name || '-'" disabled />
          <InputFrom type="text" class="w-full sm:w-[48%] md:w-[23%]" :labelColor="'#385660'"
            :label="$t('settings.labels.legalRepSurname')"
            :modelValue="adminData.legal_rep_surname || '-'" disabled />
          <InputFrom type="text" class="w-full sm:w-[48%] md:w-[23%]" :labelColor="'#385660'"
            :label="$t('settings.labels.legalRepDocument')"
            :modelValue="adminData.legal_rep_document || '-'" disabled />
          <InputFrom type="text" class="w-full sm:w-[48%] md:w-[23%]" :labelColor="'#385660'"
            :label="$t('settings.labels.notifications')"
            :modelValue="adminData.has_notifications === '' ? '-' : (adminData.has_notifications ? 'Sí' : 'No')" disabled />
          <InputFrom type="text" class="w-full sm:w-[48%] md:w-[23%]" :labelColor="'#385660'"
            :label="$t('settings.labels.seesAllRequests')"
            :modelValue="adminData.sees_all_requests ? $t('common.yes') : $t('common.no')" disabled />
          <InputFrom type="text" class="w-full sm:w-[48%] md:w-[23%]" :labelColor="'#385660'"
            :label="$t('settings.labels.commercial')"
            :modelValue="accountCommercial || adminData.commercial || '-'" disabled />
          <InputFrom type="text" class="w-full sm:w-[48%] md:w-[23%]" :labelColor="'#385660'"
            :label="$t('settings.labels.phone')"
            :modelValue="adminData.mobile || '-'" disabled />
          <InputFrom type="text" class="w-full sm:w-[48%] md:w-[23%]" :labelColor="'#385660'"
            :label="$t('settings.labels.municipality')"
            :modelValue="adminData.city || '-'" disabled />
          <InputFrom type="text" class="w-full sm:w-[48%] md:w-[23%]" :labelColor="'#385660'"
            :label="$t('settings.labels.maintenance')"
            :modelValue="adminData.maintenance === '' ? '-' : (adminData.maintenance ? 'Sí' : 'No')" disabled />
        </form>
      </div>
      <div v-else class="w-full text-center py-10 text-lg text-gray-400">Cargando datos del administrador...</div>
    </CardComponent>

    <TitlePrimary :title="$t('settings.titles.users')" class="w-full" />
    <TableComponent :fields="fields" :items="itemsFields" :showOptions="true" />
    <PaginateComponent :totalPages="totalPagesFields" :paginationInfo="paginationInfoFields" :modelValue="currentPageFields"
      @update:modelValue="handlePageChangefields" />

    <TitlePrimary :title="$t('settings.titles.files')" class="w-full" />
    <TableComponent :fields="files" :items="itemsFiles" :showOptions="true" />
    <PaginateComponent :totalPages="totalPagesFiles" :paginationInfo="paginationInfoFiles" :modelValue="currentPageFiles"
      @update:modelValue="handlePageChangefiles" />
  </div>
</template>

<script setup>
const adminData = ref({});
const loadingAdmin = ref(true);

import { ref, computed, onMounted } from 'vue';
import axios from 'axios';

import CardComponent from '@/components/card_form/CardComponent.vue';
import InputFrom from '@/components/inputs/CustomInput.vue';
import TitlePrimary from '@/components/title/title-primary.vue';
import TableComponent from '@/components/table/TableComponent.vue';
import PaginateComponent from '@/components/paginate/PaginateComponent.vue';
import { usePaginationInfo } from '@/composables/usePaginationInfo';


const fields = [
  { key: "id", label: "id" },
  { key: "name", label: "Nombre" },
  { key: "email", label: "Correo" },
  { key: "status", label: "Estado" },
];
const files = [
  { key: "date", label: "Fecha" },
  { key: "type", label: "Tipo" },
  { key: "name", label: "Nombre" },
  { key: "user", label: "Usuario" },
];

const itemsFields = ref([]);
const currentPageFields = ref(1);
const totalPagesFields = ref(1);
const { paginationInfo: paginationInfoFields, setPaginationInfo: setPaginationInfoFields } = usePaginationInfo();

const itemsFiles = ref([]);
const currentPageFiles = ref(1);
const totalPagesFiles = ref(1);
const { paginationInfo: paginationInfoFiles, setPaginationInfo: setPaginationInfoFiles } = usePaginationInfo();
// const loading = ref(true);

// Cuentas cliente de la persona. El nombre de cuenta, su tipo (Vertical u
// Horizontal) y el comercial son datos de la cuenta, no de la persona: esta
// pantalla mostraba el nombre propio y el correo en su lugar. Quien pertenece a
// varias cuentas las ve todas, separadas por «/».
const ownAccounts = ref([]);
const joinAccountField = (pick) => [...new Set(ownAccounts.value.map(pick).filter(Boolean))].join(' / ');
const accountName = computed(() => joinAccountField((account) => account.name));
const accountType = computed(() => joinAccountField((account) => account.type_label));
const accountCommercial = computed(() => joinAccountField((account) => account.commercial_label));

const fetchOwnAccounts = async () => {
  try {
    const response = await axios.get(`${import.meta.env.VITE_API_URL}/client-account/mine`, {
      headers: { 'Accept': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
    });
    ownAccounts.value = Array.isArray(response.data?.value) ? response.data.value : [];
  } catch (error) {
    console.error('Error al obtener las cuentas del administrador:', error);
    ownAccounts.value = [];
  }
};

// Personas de la propia cuenta. Antes llamaba al listado de cuentas cliente
// (/admin/list), así que un cliente veía a todos los clientes de ADS.
const fetchDataFromApi = async () => {
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}/user/list`,
      {
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        params: {
          per_page: 10,
          page: currentPageFields.value
        }
      }
    );
    if (response.data?.value.data) {
      itemsFields.value = response.data.value.data
      totalPagesFields.value = response.data.value.last_page;
      setPaginationInfoFields(response.data.value);
    }
  } catch (error) {
    itemsFields.value = [];
    console.error('Error fetching data:', error);
  }
};


const getFilesData = async () => {
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}/request/superadmin/file/list`,
      {
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        params: {
          per_page: 10,
          page: currentPageFiles.value
        }
      }
    );

    if (response.data?.value.data) {

      itemsFiles.value = response.data.value.data
      totalPagesFiles.value = response.data.value.last_page;
      setPaginationInfoFiles(response.data.value);
      console.log('files', itemsFiles.value)
    }
  } catch (error) {
    itemsFiles.value = [];
    console.error('Error fetching data:', error);
  }
};

// Manejo de cambio de página
const handlePageChangefields = (newPage) => {
  currentPageFields.value = newPage;

  fetchDataFromApi();
};
const handlePageChangefiles = (newPage) => {
  currentPageFiles.value = newPage;

  getFilesData();
};


onMounted(async () => {
  fetchDataFromApi();
  fetchOwnAccounts();
  // Obtener datos del administrador
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}/user/get/${localStorage.getItem('id')}`,
      {
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      }
    );
    if (response.data?.value) {
      adminData.value = response.data.value;
    }
  } catch (error) {
    console.error('Error al obtener datos del administrador:', error);
  } finally {
    loadingAdmin.value = false;
  }
});

</script>
